<template>
    <div class="credible-set-container">
        <button @click="performSearch" class="btn btn-outline-secondary btn-sm ml-4 btn-xs">View</button>
        <span>{{ cellValue }}</span>
    </div>
</template>

<script>
export default {
    data(){
        return {
            cellValue: ''
        }
    },
    beforeMount(){
        this.cellValue = this.params.value;
    },
    methods:{
        performSearch(){
            // Check if the performCredibleSetSearch function is provided in the context
            if (this.params.context && typeof this.params.context.performCredibleSetSearch === 'function') {
                this.params.context.performCredibleSetSearch(this.cellValue);
            }
        }
    }
}
</script>

<style scoped>
.btn-xs {
    padding: 0.125rem 0.25rem; 
    font-size: 0.75rem;
    line-height: 1; 
    margin-left: 0 !important; /*Overrides the default margin-left.*/
    margin-right: 0.5rem;
}

</style>